import React from 'react';
import './BotAvatar.css';

const BotAvatar = () => {
return(
  <div className="eatechnologies-bot-Avatar">
      EA     
  </div>
)
}

export default BotAvatar